// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "@/App.vue";
import router from "@/router";
import VueCookies from "vue-cookies";
import vueAnalytics from "vue-analytics";
import Meta from "vue-meta";
import { trackers, trackerSettings } from "@/common/consts";
import i18n from "@/common/multilanguage/i18n";
import store from "@/store";
import VueDisqus from "vue-disqus";
import axios from "axios";
// import firebase from "firebase/app";
// import "firebase/auth";
// import firebaseConfig from "./firebaseConfig";
import VueScrollTo from "vue-scrollto";
import asciiSignature from "./asciiSignature";
import ExperimentOverride from "@/components/ExperimentOverride/ExperimentOverride.vue";

Vue.use(VueCookies);
Vue.use(Meta);
Vue.use(VueDisqus);
Vue.use(VueScrollTo);

Vue.component("ExperimentOverride", ExperimentOverride);

Vue.prototype.$axios = axios;
Vue.config.productionTip = process.env.NODE_ENV === "production";

asciiSignature();

// firebase.initializeApp(firebaseConfig);

// firebase.auth().onAuthStateChanged(user => {
/*
 * Commented out until new notice
 */
// var oajsConfig = {
//     storage_type: "cookie", // "cookie" or "localStorage"
//     email: user ? user.email : "", // plain-text user email address if available
//     placementID: "16", // LiveRamp placement id
//     tdidPartnerID: "openx", // Trade Desk ID partner id
//     oaID: "lovetoknow" // OpenAudience account id
// };
// window.oajs.cmd.push(function() {
//     window.oajs.start(oajsConfig);
// });

//     store.dispatch("Login/fetchUser", user);
// });

if (typeof window.__PRERENDER_INJECTED === "undefined") {
    // Temporarily enable GA by default as hits were not registering correctly with OT
    // const otCookie = Vue.$cookies.get("OptanonConsent");
    // const parsedCookie = otCookie ? otCookie.split('&')
    //     .reduce((res, c) => {
    //         const [key, val] = c.trim().split('=').map(decodeURIComponent)
    //         try {
    //             return Object.assign(res, { [key]: JSON.parse(val) })
    //         } catch (e) {
    //             return Object.assign(res, { [key]: val })
    //         }
    //     }, {}) : {};
    // const acceptedTracking = parsedCookie.groups ? parsedCookie.groups.includes("C0002:1") : false;

    Vue.use(vueAnalytics, {
        id: () => Object.values(trackers),
        customIdFields: trackerSettings,
        router,
        ignoreRoutes: ["/dynamic-page/"],
        ready() {
            Vue.$ga.set("dimension2", window.appVersion);
        },
        debug: {
            /** Don't actually hit GA if we're not on production */
            sendHitTask: process.env.NODE_ENV === "production"
        },
        // disabled: !acceptedTracking
        // checkDuplicatedScript: true,
        // disableScriptLoader: true
    });

    Vue.use(VueScrollTo, {
        container: "body",
        duration: 500,
        easing: "ease",
        offset: 0,
        force: true,
        cancelable: true,
        onStart: false,
        onDone: false,
        onCancel: false,
        x: false,
        y: true
    });
}

/* eslint-disable no-new */
new Vue({
    el: "#app",
    store,
    router,
    i18n,
    components: { App },
    render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js